<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/warehousesRequest/">Account Requests</a></li>
      <li class="breadcrumb-item active" aria-current="page">Create Customer</li>
    </ol>
  </nav>
  <div class="invalid-feedback d-block shift-invalid-text" [hidden]="!errorMessage">{{errorMessage}}</div>
  <div class="row">
    <div class="col">
      <div class="inner-box">
        <div class="row">
          <div class="col-md-5 required">
            <h2 class="text-black mb-3 control-label">Select Customer Type</h2>
            <div class="form-radio">
              <input type="radio" name="customerType" id="Vendor">
              <label for="Vendor">Vendor</label>
            </div>&nbsp;&nbsp;
            <div class="form-radio">
              <input type="radio" name="customerType" id="Customer">
              <label for="Customer">Customer</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col">
      <div class="inner-box">
        <div class="row mt-3">
          <div class="col-md-12 col-md-8">
            <div class="row">
              <div class="col-md-3 required">
                <label class="control-label" for="companyName">Company Name</label>
                <div class="form-group companyName ">
                  <input type="text" id="companyName" [(ngModel)]="companyName" [ngModelOptions]="{standalone: true}"
                         class="form-control" (blur)="typeCompanyName()" [ngClass]="{'is-invalid':statusText1}"
                         onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                         autocomplete="off" (blur)="createCompanyName()" required>
                </div>
              </div>
              <div class="col-md-3 required">
                <label class="control-label" for="conactName">Contact Name</label>
                <div class="form-group ">
                  <input type="text" id="conactName" [(ngModel)]="name" [ngModelOptions]="{standalone: true}"
                         class="form-control" (blur)="typeContactName()" [ngClass]="{'is-invalid':statusText2}"
                         onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                         autocomplete="off" (blur)="createContactName()" required>
                </div>
              </div>
              <div class="col-md-3 required">
                <label class="control-label" for="contactNumber">Phone Number</label>
                <div class="form-group ">
                  <div class="invalid-feedback d-block shift-invalid-text" [hidden]="!mobileValidationMessage">
                    {{mobileValidationMessage}}
                  </div>
                  <input type="text" id="contactNumber" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                         [(ngModel)]="mobileNumber" (blur)="typePhoneNumber()" [ngClass]="{'is-invalid':statusText3}"
                         [ngModelOptions]="{standalone: true}" maxlength="10" class="form-control"
                         (blur)="createMobile()" required>
                </div>
              </div>
              <div class="col-3 required">
                <label class="control-label" for="email">Email</label>
                <div class="form-group ">
                  <input type="text" id="email" [(ngModel)]="email" [ngModelOptions]="{standalone: true}"
                         (blur)="typeValidateEmail()" [ngClass]="{'is-invalid':statusText9}" class="form-control"
                         required>
                </div>
              </div>
            </div>
            <div class="row">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">

    <div class="col-md-12 mb-1 text-danger fw-500"
         *ngIf="statusText1 || statusText2 || statusText3 || statusText9 || statusText12 || statusText4 || statusText6 || statusText7 || statusText8">
      Please Enter Mandatory Fields
    </div>

    <div class="col-12">
      <ul class="list-inline tab-list">
        <li class="list-inline-item ml-2"><a class="list-inline-item" (click)=" tabChange('address');"
                                             [ngClass]="{'active': tabClicked === 'address'}">Address
          <div class="dot bg-danger ml-2"
               *ngIf=" statusText12 || statusText4 || statusText6 || statusText7 || statusText8"></div>
        </a></li>
        <li class="list-inline-item ml-3"><a class="nav-link warehouses" (click)=" tabChange('warehouses');"
                                             [ngClass]="{'active': tabClicked === 'warehouses'}">Warehouses</a></li>
        <li class="list-inline-item ml-3"><a class="nav-link additionalInfo" (click)=" tabChange('additionalInfo');"
                                             [ngClass]="{'active': tabClicked === 'additionalInfo'}">Additional Info</a>
        </li>
      </ul>
      <div class="inner-box" *ngIf="tabClicked == 'address'">
<!--        <div class="row">
          <div class="col-10">
            <div class="row">
              <div class="col-6 required">
                <label class="control-label" for="addressType">Address Type</label>
                <div class="form-group">
                  <select id="addressType" class="form-control" [(ngModel)]="addressType"
                          (blur)="selectAddressType()" [ngClass]="{'is-invalid':statusText12}"
                          [ngModelOptions]="{standalone: true}" required>
                    <option *ngFor="let a of addressTypes" [ngValue]="a.config">{{a.config}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>-->
        <div class="row">
          <div class="col-10">
            <div class="row">
              <div class="col-6 required">
                <label class="control-label" for="Address">Address1</label>
                <div class="form-group ">
                  <input type="text" id="Address" [(ngModel)]="address1" [ngModelOptions]="{standalone: true}"
                         class="form-control" (blur)="typeAddress()" [ngClass]="{'is-invalid':statusText4}" required>
                </div>
              </div>
              <div class="col-6">
                <label class="control-label" for="Address2">Address2</label>
                <div class="form-group">
                  <input type="text" id="Address2" [(ngModel)]="address2" [ngModelOptions]="{standalone: true}"
                         class="form-control">
                </div>
              </div>
            </div>
          </div>
          <div class="col-10">
            <div class="row">
              <div class="col-4 required">
                <label class="control-label">City</label>
                <div class="form-group ">
                  <ng-select type="text" id="city" [(ngModel)]="city" [ngModelOptions]="{standalone: true}"
                             (blur)="typeCity()" [ngClass]="{'is-invalid':statusText6}" placeholder="City"
                             [items]="citiesList" [addTag]="true"
                             onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                             autocomplete="off" required>
                  </ng-select>
                </div>
              </div>
              <div class="col-4 required">
                <label class="control-label">State</label>
                <div class="form-group">
                  <ng-select id="State" [(ngModel)]="state" [ngModelOptions]="{standalone: true}"
                             [ngClass]="{'service-error':statusText7}"
                             (blur)="typeState()"
                             [ngClass]="{'is-invalid':statusText7}"
                             [items]="statesList"
                             placeholder="State">
                  </ng-select>
                </div>
              </div>
              <div class="col-4 required">
                <label class="control-label" for="zip">Zip</label>
                <div class="form-group ">
                  <input type="text" onkeypress='return event.charCode >= 48 && event.charCode <= 57' id="zip"
                         placeholder="Enter PinCode"
                         [(ngModel)]="zip" maxlength="6" [ngModelOptions]="{standalone: true}" class="form-control"
                         (change)="changeStateAndCity()"
                         (blur)="zipCode()" [ngClass]="{'is-invalid':statusText8}" required>
                </div>
              </div>
            </div>

          </div>
        </div>

        <button class="btn ml-2 btn-outline-primary">
          <svg class="bi bi-plus mr-2" width="1.5em" height="1.5em" viewBox="0 0 16 16" fill="currentColor"
               xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
                  d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"></path>
            <path fill-rule="evenodd" d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"></path>
          </svg>
          Add Address
        </button>

      </div>
    </div>
  </div>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/warehousesRequest" id="cancelList" class="btn btn-cancel-prime">Cancel
      </button>
      <button type="submit" *ngIf="tabClicked === 'address'" id="nextValidations" (click)="checkValidations();"
              class="btn btn-orange-prime ml-2">Next
      </button>
      <button type="submit" *ngIf="tabClicked === 'warehouses'" id="next" (click)=" tabChange('additionalInfo');"
              class="btn btn-orange-prime ml-2">Next
      </button>
      <button type="submit" *ngIf="tabClicked === 'additionalInfo'" id="save" (click)="submit()"
              class="btn btn-orange-prime ml-2">Save
      </button>
    </div>
  </div>
</div>
